var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "org-tree-layout" },
      [
        _c("swb-popover-org-tree", {
          attrs: { showMgmt: true, showIncludeSubComs: true },
          on: {
            "notity-change": function($event) {
              _vm.checkComCatChange($event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { name: "query-sort-block" } },
      [
        _c("swb-query-sort-area", {
          ref: "query_model_ctrl",
          attrs: {
            confKey: _vm.confKey,
            configAuto: true,
            queryOnLoad: _vm.queryOnLoad,
            queryHandler: _vm.queryHandler
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.curComLevel == 1
      ? _c("div", { staticClass: "simple-row clearfix" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "div",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.feedbackSave()
                  }
                }
              },
              [_vm._v("新增")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.feedbackList, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "typeName",
                label: "反馈类型",
                width: "150",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "content",
                label: "问题描述",
                width: "260",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "userName",
                label: "创建人",
                width: "150",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "createTime",
                label: "创建时间",
                width: "180",
                align: "center"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "处理状态", width: "100", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.handleFlag == 1
                        ? _c("a", [_vm._v("已处理")])
                        : _vm._e(),
                      _vm._v(" "),
                      rows.row.handleFlag == -1
                        ? _c("a", [_vm._v("不予处理")])
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "replyContent",
                label: "回复内容",
                align: "left",
                "show-overflow-tooltip": ""
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-layout" },
      [
        _c("el-pagination", {
          attrs: {
            background: "",
            "page-size": _vm.pageSize,
            "page-sizes": _vm.pageSizes,
            "current-page": _vm.pageNumber,
            total: _vm.totalCount,
            layout: "prev, pager, next, jumper, sizes, total"
          },
          on: {
            "current-change": _vm.handlePageChange,
            "size-change": _vm.handleSizeChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7cf81b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7cf81b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/feedback/FeedbackList.vue
// module id = 3721
// module chunks = 0